import React from 'react';
import './supplierInvoices.scss';

import SupplierInvoiceDetailRows from './supplierInvoiceDetailRows.js';
import SupplierInvoiceTransactions from './supplierInvoiceTransactions.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useState, useEffect, useCallback  } from "react";



export default function SupplierInvoiceDetail(props) {


  const onTabSelectionChanged = useCallback((e) => {
    //notify("The button was clicked");
    ;
  }, []); 

 
  function renderDetailRowsTab() {
    return <SupplierInvoiceDetailRows myKey = {props.data.key} status = {props.data.data.statoId} />;
  }

  function renderTransactionsTab() {
    return <SupplierInvoiceTransactions myKey = {props.data.key} status = {props.data.data.statoId}  data = {props.data.data}/>;
  }

  return (

    <div>

      <div className="offer-title" align="left" > 
        <h2>Fattura n° {props.data.data.numeroDoc} del {props.data.data.strDataDoc} -  {props.data.data.fornitore}</h2>      
      </div>

      <TabPanel    
        onSelectionChanged={onTabSelectionChanged}
      >
        <Item title="Dettaglio" render={renderDetailRowsTab} />
        <Item title="Pagamenti"  render={renderTransactionsTab}/>
      </TabPanel>

    </div>  
   
  )
};